import { render, staticRenderFns } from "./AscUserAccountButton.vue?vue&type=template&id=180d0de7&"
import script from "./AscUserAccountButton.vue?vue&type=script&lang=js&"
export * from "./AscUserAccountButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports